import { render, staticRenderFns } from "./DescriptionModal.vue?vue&type=template&id=f513d3a0"
import script from "./DescriptionModal.vue?vue&type=script&lang=ts"
export * from "./DescriptionModal.vue?vue&type=script&lang=ts"
import style0 from "./DescriptionModal.vue?vue&type=style&index=0&id=f513d3a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports